import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useUserEmailSettings } from '../../../sic-lib/api/hooks/useUserEmailSettings';
import { USER_EMAIL_SETTINGS_DEFAULT } from '../../../sic-lib/defaults';
import { GenericReducer, genericReducer } from '../../../sic-lib/reducers/genericReducer';
import { EmailSettings } from '../../../sic-lib/types/EmailSettings';
import Loader from '../../Shared/Loader';
import SelectUserEmail from './SelectUserEmail/SelectUserEmail';
import UserEmailAdvanced from './UserEmailAdvanced/UserEmailAdvanced';
import UserEmailButtonGroup from './UserEmailButtonGroup/UserEmailButtonGroup';

export default function UserEmailSettings() {
    const { classes } = useStyles();

    const [userEmailSettings, setUserEmailSettings] = React.useReducer<
        GenericReducer<EmailSettings>
    >(genericReducer, USER_EMAIL_SETTINGS_DEFAULT);

    const { data: emailSettingsData, isLoading: isEmailSettingsLoading } = useUserEmailSettings();

    React.useEffect(() => {
        if (emailSettingsData) {
            setUserEmailSettings(emailSettingsData);
        }
    }, [emailSettingsData]);

    const [showAdvanced, setShowAdvanced] = React.useState<boolean>(false);

    const changeSettingsHandler = (name: string, value: string | boolean | number) => {
        setUserEmailSettings({ [name]: value });
    };

    return (
        <Loader isLoading={isEmailSettingsLoading}>
            <Paper sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container flexDirection="column" spacing={2} p={2}>
                    <SelectUserEmail
                        email={userEmailSettings.emailUserName}
                        password={userEmailSettings.emailUserPassword}
                        status={userEmailSettings.status}
                        isShowAdvance={setShowAdvanced}
                        onSettingsChange={setUserEmailSettings}
                    />
                    <UserEmailButtonGroup
                        isShowAdvanced={showAdvanced}
                        onShowAdvanced={setShowAdvanced}
                        userEmailSettings={userEmailSettings}
                        onSettingsChange={setUserEmailSettings}
                        // onSaveHandler={handleSave}
                        // saveReq={requestStatus}
                    />
                    {showAdvanced && (
                        <>
                            <UserEmailAdvanced
                                isImap={true}
                                hostName={userEmailSettings.imapHost}
                                port={userEmailSettings.imapPort}
                                ssl={userEmailSettings.imapUseSsl}
                                onSettingsChange={changeSettingsHandler}
                            />
                            <UserEmailAdvanced
                                isImap={false}
                                hostName={userEmailSettings.smtpHost}
                                port={userEmailSettings.smtpPort}
                                ssl={userEmailSettings.smtpUseSsl}
                                onSettingsChange={changeSettingsHandler}
                            />
                        </>
                    )}
                </Grid>
            </Paper>
        </Loader>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
